import React from 'react';
import { CopyPlus, FolderInput, Pin, PinOff, Printer, Download, Link2, Trash2 } from 'lucide-react';

/** Icons of the more-menu entries (stroke 1.6, like the artboard). */
export function MenuIcon({ id, pinned }) {
  const props = { size: 16, strokeWidth: 1.6, 'aria-hidden': true, className: 'doc-mm-icon' };
  switch (id) {
    case 'duplicate':
      return <CopyPlus {...props} />;
    case 'move':
      return <FolderInput {...props} />;
    case 'pin':
      return pinned ? <PinOff {...props} /> : <Pin {...props} />;
    case 'print':
      return <Printer {...props} />;
    case 'export':
      return <Download {...props} />;
    case 'copyLink':
      return <Link2 {...props} />;
    case 'trash':
      return <Trash2 {...props} />;
    default:
      return null;
  }
}

const svg = (children, className) => (
  <svg
    className={`doc-mm-format-icon ${className}`}
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

/** The Export submenu's format glyphs (red page, blue M↓, orange </>) — drawn as on the artboard. */
export function FormatIcon({ id }) {
  if (id === 'pdf') {
    return svg(
      <>
        <path d="M6 3h8l5 5v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
        <path d="M14 3v5h5M9 17v-5h2a1.5 1.5 0 0 1 0 3H9" />
      </>,
      'doc-mm-format-icon--pdf'
    );
  }
  if (id === 'markdown') {
    return svg(
      <>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="M7 15V9l2.5 3L12 9v6M16 9v6l2-2M16 15l-2-2" />
      </>,
      'doc-mm-format-icon--md'
    );
  }
  return svg(<path d="m8 8-4 4 4 4M16 8l4 4-4 4M14 5l-4 14" />, 'doc-mm-format-icon--html');
}
